const INACTIVITY_LIMIT = (14 * 60 + 59) * 1000; // 14min.59sec (total in milliseconds)
let timeout;

const resetTimer = () => {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    if (window.navbar && window.navbar.navbar.user_type !== 'Admin') {
      logoutUser();
    }
  }, INACTIVITY_LIMIT);
}

const hrefBuilder = (subdomain, path) => {
    const domainSplit = document.location.host.split('.');
    domainSplit[0] = subdomain;
    return location.protocol + '//' + domainSplit.join('.') + path;
};

const logoutUser = () => {
  let loginLink = hrefBuilder('app', '/users/sign_in')
  // Redirect to the login page
  window.location.href = loginLink;
}

// Listen for user activity
window.addEventListener("mousemove", resetTimer);
window.addEventListener("keydown", resetTimer);
window.addEventListener("click", resetTimer);
window.addEventListener("scroll", resetTimer);

// Initialize the timer when the page loads
resetTimer();
